import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Configuración de Local
import localeEs from '@angular/common/locales/es'; // Español

import { NgSelectModule } from '@ng-select/ng-select';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

import { NavbarModule } from '../navbar/navbar.module';
import { FooterModule } from '../footer/footer.module';
import { ContactoModule } from '../contacto/contacto.module';

import { RecaptchaModule } from 'ng-recaptcha';
import { ComponentesModule } from '../../componentes/componentes.module';

import { PagesRoutingModule } from './pages-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
// import { ScrollingModule } from '@angular/cdk/scrolling';
// import { MatButtonModule } from '@angular/material/button';
// import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { NumberWithCommasPipe } from 'src/app/shared/pipes/number-with-commas.pipe';
import { FormatTextPipe } from 'src/app/shared/pipes/format-text.pipe';
import { FormatearDiasPipe } from 'src/app/shared/pipes/formatear-dias.pipe';

// import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { RegistroCortoComponent } from './candidato/registro-corto/registro-corto.component';
import { RegistroExitosoComponent } from './notificaciones/registro-exitoso/registro-exitoso.component';
import { ValidacionEmailComponent } from './notificaciones/validacion-email/validacion-email.component';
import { HomeComponent } from './candidato/home/home.component';
import { JobCardComponent } from './candidato/components/job-card/job-card.component';
import { FilterSearchJobComponent } from './candidato/components/filter-search-job/filter-search-job.component';
import { SearchJobComponent } from './candidato/search-job/search-job.component';
import { LoginComponent } from './candidato/login/login.component';
import { PostulacionComponent } from './candidato/postulacion/postulacion.component';
import { FormStepsComponent } from './candidato/components/form-steps/form-steps.component';
import { ResetPasswordComponent } from './candidato/reset-password/reset-password.component';
import { SolicitudResetPasswordComponent } from './candidato/solicitud-reset-password/solicitud-reset-password.component';

import { CandidatoPerfilComponent } from './candidato/candidato-perfil/candidato-perfil.component';
import { CargaCvComponent } from './candidato/carga-cv/carga-cv.component';
import { OpcionesRegistroComponent } from './candidato/opciones-registro/opciones-registro.component';

registerLocaleData(localeEs); // Registra el locale español

@NgModule({
  declarations: [
    RegistroCortoComponent,
    RegistroExitosoComponent,
    ValidacionEmailComponent,
    HomeComponent,
    JobCardComponent,
    SearchJobComponent,
    FilterSearchJobComponent,
    LoginComponent,
    PostulacionComponent, 
    FormStepsComponent,
    ResetPasswordComponent,
    SolicitudResetPasswordComponent,
    CandidatoPerfilComponent,
    CargaCvComponent,
    OpcionesRegistroComponent,
    NumberWithCommasPipe,
    FormatTextPipe,
    FormatearDiasPipe
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxIntlTelInputModule,
    PagesRoutingModule,
    NavbarModule,
    FooterModule,
    ContactoModule,
    ComponentesModule,
    RecaptchaModule,
    TranslateModule,
    MatAutocompleteModule,
    // ScrollingModule,
    // MatButtonModule,
    // MatCardModule,
    MatProgressSpinnerModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-MX' }
  ],
  exports: [
    RouterModule,
    FormStepsComponent
  ]
  // ,providers: [
  //   {
  //     provide: RECAPTCHA_V3_SITE_KEY,
  //     useValue: '6LfZgvIqAAAAAHtXYWCS0GEAy6k_z-V4LZdBeBy5', // Reemplázalo con tu clave de Google
  //   },
  // ],
})
export class PagesModule { }